import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { SlotImage } from '@/features/designer/components/SlotImage'

export function PhotoshootBannerSection() {
  return (
    <section className="relative overflow-hidden min-h-[480px] flex items-end border-b">
      {/* Background slot image */}
      <SlotImage
        slotKey="homepage-photoshoot"
        className="absolute inset-0 w-full h-full"
        alt="Free photoshoot background"
        fallback={
          <div className="absolute inset-0 bg-gradient-to-br from-brand-purple-light to-background dark:from-brand-purple-dim" />
        }
      />

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="container mx-auto px-4 py-16 space-y-6 text-brand-white text-center flex flex-col items-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl leading-tight">
            Our subscribers get the chance to win a free photoshoot!
          </h1>
          <Link to="/applications/photoshoot-giveaway">
            <Button size="lg">Register</Button>
          </Link>
        </div>
      </div>
    </section>
  )
}
